let sendToAnalytics

/**
 * @reference https://web.dev/vitals/
 */
const reportWebVitals = () => {
  if (sendToAnalytics && typeof sendToAnalytics === 'function') {
    import('web-vitals')
      // eslint-disable-next-line promise/always-return
      .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        getCLS(sendToAnalytics)
        getFID(sendToAnalytics)
        getFCP(sendToAnalytics)
        getLCP(sendToAnalytics)
        getTTFB(sendToAnalytics)
      })
      // eslint-disable-next-line no-console
      .catch((err) => console.error('Can not report web vitals', err))
  }
}

export default reportWebVitals
